import axios from 'axios';
import logger from 'common/utils/udp-logger';

import requestInstance from './requestInstance';

// 判断获取的词条地址是否为合法的 url（结尾是.js或.json，允许查询参数）
function isValidUrl(str) {
  return /^(https?:\/\/).+\.(js|json)(\?.*)?$/i.test(str);
}

async function getI18NData(id, lang) {
  try {
    const result = await requestInstance.get(`/api/mid/common/getI18nData?id=${id}&lang=${lang}`);
    return result.data;
  } catch (error) {
    logger.error({
      event: 'getI18N-Data-error',
      id,
      lang,
      error,
    });
    return '';
  }
}

export default async function request(id, lang) {
  try {
    const i18nDataRes = await getI18NData(id, lang);
    const i18nDataCdn = i18nDataRes.data || i18nDataRes;
    if (!i18nDataCdn) {
      logger.error({
        event: 'geti18n-DataCdn-error',
        id,
        lang,
      });
      return '{}';
    }
    if (isValidUrl(i18nDataCdn)) {
      // 返回的值存在EO的js挑战可能性，只有当url合法时才进行请求
      logger.info({
        event: 'geti18n-DataCdn-success',
        id,
        lang,
        i18nDataCdn,
      });
      return await axios.get(i18nDataCdn).then(async (res) => {
        const reg = new RegExp('(?<=\\{"\\d+":).+(?=\\}\\))', 'g');
        const resMatch = res?.data?.match(reg);
        return resMatch && resMatch.length > 0 ? resMatch[0] : '{}'; // 如果data为空，返回 '{}' ，这是避免 JSON.parse 报错
      });
    }
    // 返回的如果是eo的js挑战，直接返回
    logger.info({
      event: 'geti18n-DataCdn-EO-error',
      id,
      lang,
    });
    return '{}';
  } catch (error) {
    logger.error({ event: 'geti18n-DataCdn-unknown-error', id, lang, error });
    return '{}';
  }
}
// 传入url获取获取的词条数据
export async function requestCdnData(i18nDataCdn) {
  try {
    if (isValidUrl(i18nDataCdn)) {
      // 返回的值存在EO的js挑战可能性，只有当url合法时才进行请求
      logger.info({
        event: 'geti18n-DataCdn-success',
        i18nDataCdn,
      });
      return await axios.get(i18nDataCdn).then(async (res) => {
        const reg = new RegExp('(?<=\\{"\\d+":).+(?=\\}\\))', 'g');
        const resMatch = res?.data?.match(reg);
        return resMatch && resMatch.length > 0 ? resMatch[0] : '{}'; // 如果data为空，返回 '{}' ，这是避免 JSON.parse 报错
      });
    }
    // 返回的如果是eo的js挑战，直接返回
    logger.info({
      event: 'geti18n-DataCdn-EO-error',
      i18nDataCdn,
    });
    return '{}';
  } catch (error) {
    logger.error({ event: 'geti18n-DataCdn-unknown-error', i18nDataCdn, error });
    return '{}';
  }
}
